<template>
  <div class="group-billings">
    <div class="group-billing group-billing-bottom group-billing-margin" v-if="showGroupName">
      <div class="group-billing-title">{{ groupName.title }}</div>
      <div class="group-billing-content">{{ groupName.content }}</div>
    </div>
    <div class="group-billing" v-for="(groupBilling, index) of groupBillingDetail" :key="groupBilling.title">
      <div class="group-billing-title">{{ groupBilling.title }}</div>
      <div class="group-billing-content">{{ groupBilling.content }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { filterCountryName } from '@/client/utils/filters'
import { TGroupBilling } from '@/typings/api/group_billings.type'

// 契約情報の入力画面からは、グループ名を持たない入力中のフォームの値が渡る
type GroupBillingPreview = Omit<TGroupBilling, 'groupId' | 'group'> & Partial<Pick<TGroupBilling, 'group'>>

export default defineComponent({
  props: {
    groupBilling: { type: Object as PropType<GroupBillingPreview>, required: true }
  },
  computed: {
    showGroupName() {
      return Boolean(this.groupBilling?.group?.name)
    },

    groupName() {
      return {
        title: 'グループ名',
        content: this.groupBilling?.group?.name
      }
    },

    getAllAddress() {
      const address: string[] = []
      if (this.groupBilling.countryCode) address.push(filterCountryName(this.groupBilling.countryCode))

      if (this.groupBilling.zipCode) {
        const zipCode = this.groupBilling.zipCode.replace(/-/g, '')

        // 日本の郵便番号の先頭に「〒」を追加し、ハイフンで区切られた形式にフォーマットする
        // 例: '1234567' => '〒123-4567'
        address.push('〒' + zipCode.slice(0, 3) + '-' + zipCode.slice(3))
      }

      if (this.groupBilling.address) address.push(this.groupBilling.address)

      return address.join('\n')
    },

    groupBillingDetail() {
      return [
        {
          title: '会社名',
          content: this.groupBilling.companyName
        },
        {
          title: '担当部署名',
          content: this.groupBilling.departName
        },
        {
          title: '担当者名',
          content: this.groupBilling.personName
        },
        {
          title: 'メールアドレス',
          content: this.groupBilling.email
        },
        {
          title: '住所',
          content: this.getAllAddress
        },
        {
          title: '電話番号',
          content: this.groupBilling.telephone
        }
      ]
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.group-billing {
  display: flex;
  border-top: 1px solid $border-color;
  border-right: 1px solid $border-color;
  border-left: 1px solid $border-color;

  &-bottom {
    border-bottom: 1px solid $border-color;
  }

  &-margin {
    margin-bottom: 2 * $spacing-unit;
  }

  &-title {
    width: 15%;
    padding: $spacing-unit;
    font-weight: 700;
    background: $background-color;
    border-right: 1px solid $border-color;
  }

  &-content {
    flex: 1;
    padding: $spacing-unit;
    white-space: pre-wrap;
  }

  &:last-child {
    border-bottom: 1px solid $border-color;
  }
}
</style>
